import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import * as page from '../../pages/pages';

@Component({
	selector: 'page-topics',
	templateUrl: 'topics.html',
})

export class TopicsPage {

	homeMenu: Array<{ title: string, icon: string, pageName: string}>;
	menuDisplay: any;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams) {
	}

	ionViewDidLoad() {
		this.menuDisplay = [
			{ title: 'eAssessment', icon: 'check-square-o', pageName: 'eassessment'},
			{ title: 'eLearning', icon: 'television', pageName: 'elearning'},
			{ title: 'Badging', icon: 'star', pageName: 'badging'},
			{ title: 'Bespoke eLearning', icon: 'graduation-cap', pageName: 'bespoke-elearning'},
			{ title: 'Consultancy', icon: 'comments', pageName: 'consultancy'},
			{ title: 'Bespoke Development', icon: 'pencil', pageName: 'bespoke-development'},
		];
	}


	goToPage(tile) {
		this.navCtrl.push(page.CaseStudiesPage, 
			{ "pageObj": tile }
		);
	}

}



// WEBPACK FOOTER //
// ./src/pages/topics/topics.ts